import Head from "next/head";
import { useRouter } from "next/dist/client/router";
import { useContext, useEffect } from "react";

import PageContainer from "../components/pageContainer";
import PageHeader from "../components/pageHeader";
import SearchContainer from "../components/searchContainer";
import SortByDropdown from "../components/sortByDropdown";

import useSearch from "../hooks/useSearch";

import AuthGuard from "../components/authGuard";
import { TranslationContext } from "../context/TranslationContext";

export default function Search() {
  const { i } = useContext(TranslationContext);
  const { setSortBy, preferencesLoaded, members, fetchResults } = useSearch();

  const router = useRouter();

  if (
    typeof window !== "undefined" &&
    /search-by-username/.test(window.location.href)
  ) {
    router.push("/search-by-username");
  }

  useEffect(() => {
    if (!preferencesLoaded) return;

    if (members.length !== 0) return;

    fetchResults(false);
  }, [preferencesLoaded]);

  return (
    <AuthGuard>
      <div>
        <Head>
          <title>{i("Search")}</title>
          <meta name="robots" content="noindex" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
          />
        </Head>
        <main>
          <PageContainer pagesWithNotification={[]} currentPage="Search">
            <div className="flex md:flex-row flex-col md:justify-between md:items-end md:space-y-0 space-y-5">
              <PageHeader title={i("Search")} />
              <div className="md:mr-3 mr-auto sm:flex">
                <SortByDropdown
                  onChange={(value) => setSortBy(value)}
                  values={[
                    { id: "all", name: i("All") },
                    { id: "newest", name: i("New singles") },
                    { id: "mostpopular", name: i("Most popular") },
                  ]}
                />
              </div>
            </div>
            <SearchContainer />
          </PageContainer>
        </main>
      </div>
    </AuthGuard>
  );
}
